<template>
  <div class="container">
    <div class="ui middle aligned grid">
      <h1>Sequence</h1>
    </div>

    <div id="table">
      <div class="filter-bar ui grid">
        <div class="ui three column stackable grid form">
          <div class=" column">
            <div class="ui fluid search selection dropdown" id="MachineSelect">
              <input
                type="hidden"
                name="machines"
                v-model="machineId"
                id="Machine"
                @change="onMachineChange"
              />
              <div class="default text">Select Machine</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="machine in machines"
                  :key="machine.value"
                  v-bind:data-value="machine.value"
                >
                  {{ machine.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="ui fluid search selection dropdown" id="AssemblySelect">
              <input
                type="hidden"
                name="Assembly"
                v-model="assemblyId"
                id="Assembly"
                @change="onAssemblyChange"
              />
              <div class="default text">Select Assembly</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in assemblies"
                  :key="assembly.value"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <button class="ui primary button" @click="doFilter">Update</button>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :fields="fields"
        :api-url="apiUrl"
        :load-on-start="false"
        :data="parts"
        pagination-path=""
        :per-page="10"
        :multi-sort="true"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="code" slot-scope="props">
          <div class="nowrap">
            <a class="ui link" @click="goToPart(props.rowData)">{{ props.rowData.code }}</a>
          </div>
        </template>
        <template slot="price" slot-scope="props">
          {{ props.rowData.price | currency }}
        </template>
        <template slot="sortorder" slot-scope="props">
          <div class="ui input sequence-order text-center">
            <input
              v-model="props.rowData.sequence"
              class="text-center"
              type="number"
              @change="onSequenceChange(props.rowData)"
            />
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vue2Filters from "vue2-filters";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";

Vue.use(Vue2Filters);

export default {
  name: "Sequence",
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      Name: "Sequence",
      fields: [
        {
          name: "item",
          title: "Item",
        },
        {
          name: "__slot:code",
          title: "Code",
        },
        {
          name: "description",
          title: "Description",
        },
        {
          name: "__slot:price",
          title: "Price",
        },
        {
          name: "__slot:sortorder",
          title: "Sequence #",
        },
      ],
      parts: [],
      apiUrl: apiService.getSequenceUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      moreParams: {},
      search: [
        {
          machineId: "",
          assemblyId: "",
        },
      ],
      machines: [],
      machineId: "",
      assemblies: [],
      assemblyId: "",
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown({ fullTextSearch: true });
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());

    this.getMachineSelectedItems();
  },
  methods: {
    goToPart(part) {
      this.$router.push({
        name: "EditParts",
        params: {
          id: part.id,
        },
      });
    },
    allcap(value) {
      return value.toUpperCase();
    },
    onSequenceChange(data) {
      // console.log(data);
      this.partUpdate(data);
    },
    getMachineSelectedItems() {
      apiService.getMachinesList().then((data) => {
        this.machines = data;
      });
    },
    getAssemblySelectedItems() {
      apiService
        .getAssembliesByMachineList({ id: this.machineId })
        .then((data) => {
          this.assemblies = data;

          $(".ui.dropdown").dropdown({ fullTextSearch: true });
        });
    },
    onMachineChange(event) {
      this.machineId = event.target.value;
      this.search.machineId = this.machineId;
      this.assemblies = [];
      this.assemblyId = "";
      this.getAssemblySelectedItems();
    },
    onAssemblyChange(event) {
      this.assemblyId = event.target.value;
      this.search.assemblyId = this.assemblyId;
    },
    partUpdate(data) {
      // console.log(data);

      apiService
        .updatePart({
          id: data.id,
          Item: data.item,
          Code: data.code,
          Description: data.description,
          QuantityPerMachine: data.quantityPerMachine,
          Price: data.price,
          Sequence: data.sequence,
          SortOrder: data.sortOrder,
          machineId: data.machineId,
          assemblyId: data.assemblyId,
          Active: data.active,
        })
        .then()
        .catch((err) => this.Failed(err));
    },
    Failed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      this.$events.fire("filter-set", this.search);
    },
    onChange(event) {
      this.search.filter = event.target.value;
    },
    onFilterSet(data) {
      this.moreParams.machineId = data.machineId;
      this.moreParams.assemblyId = data.assemblyId;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    destroyed: function() {
      this.$events.off("filter-set");
      this.$events.off("filter-reset");
    },
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  },
};
</script>

<style scoped></style>
